const al = {
  book_appointment_meeting_step_title: 'Vendndodhja',
  book_appointment_meeting_step_subtile: 'Përcakto vendin e takimit',
  book_appointment_confirm_appointment_button_title: 'Lista e takimeve',
  book_appointment_confirm_calendar_button_title: 'Shto në kalendar',
  book_appointment_confirm_calendar_failure_title: 'Rezervimi nuk u krijua me sukses',
  book_appointment_confirm_calendar_success_title: 'Takimi u shtua në kalendar',
  book_appointment_confirm_subtitle: 'Takimi është konfirmuar për: ',
  book_appointment_confirm_title: 'Rezervimi u krye me sukses',
  book_appointment_date_available_slots: 'Oraret e lira',
  book_appointment_date_cta_button_title: 'Vazhdo',
  book_appointment_date_format: 'EEEE \'%1$s\' \'of\' MMMM',
  book_appointment_timeslot_step_subtile: 'Përzgjidh orarin e dëshiruar',
  book_appointment_timeslot_step_title: 'Data',
  book_appointment_service_step_duration: 'Kohëzgjatja: %1$s',
  book_appointment_service_step_subtile: 'Zgjidh shërbimin',
  book_appointment_service_step_title: 'Shërbimi',
  book_appointment_store_cta_button_title: 'Vazhdo',
  book_appointment_store_open_time_title: 'I hapur',
  book_appointment_store_step_title: 'Vendndodhja',
  book_appointment_summary_cta_button_title: 'Konfirmo',
  book_appointment_summary_step_assistance: 'Suport',
  book_appointment_summary_step_privacy_hyperlink_text: 'politikën e kthimit',
  book_appointment_summary_step_subtile: 'Përmbledhje e takimit',
  book_appointment_summary_step_terms: "Duke shtypur 'Konfirmo' ti pranon %1$s si dhe %2$s.",
  book_appointment_summary_step_terms_hyperlink_text: 'kushtet dhe afatet',
  book_appointment_summary_step_title: 'Përmbledhje',
  book_appointment_requirements_card_title: 'Kërkesat',
  book_appointment_view_location: 'Shiko vendndodhjen',
  book_appointment_timeslots_available: 'Fashat e rezervimit të orareve',
  book_appointment_timeslots_no_available: 'Nuk ka asnjë orar të lirë',
  book_appointment_add_location: 'Shto vendndodhjen',
  book_appointment_continue: 'Vazhdo',
  book_appointment_or: 'ose',
  book_appointment_service_step_subtile_admin: 'Zgjidh shërbimin',

  date_picker_days_friday: 'P',
  date_picker_days_monday: 'H',
  date_picker_days_saturday: 'Sh',
  date_picker_days_sunday: 'D',
  date_picker_days_thursday: 'E',
  date_picker_days_tuesday: 'M',
  date_picker_days_wednesday: 'M',
  your_appointments_book_button: 'Rezervo një takim tjetër',
  your_appointments_cancel_booking_button: 'Anullo rezervimin',
  your_appointments_change_booking_button: 'Ndrysho rezervimin',
  your_appointments_get_store_directions_button: 'Gjej dyqanin',
  your_appointments_header_title: 'Në pritje',
  your_appointments_history_header_title: 'Historiku i takimeve',
  your_appointments_history_no_appointment_title: 'Ti nuk ke asnjë takim në pritje',
  your_appointments_no_appointment_title_previous: "Ti nuk ke takime të mëparshme",
  your_appointments_history_request_again_button: 'Rezervo përsëri',
  your_appointments_history_review_button: 'Rishiko',
  your_appointments_no_appointment_description: 'Servis, zgjidhje të problemeve, informacion rreth produkteve ose shërbimeve të reja.',
  your_appointments_no_appointment_subtitle: 'Ti mund të rezervosh një takim në dyqan me një nga përfaqësuesit tanë.',
  your_appointments_no_appointment_title: 'Ti nuk ke takime në pritje',
  your_appointments_screen_title: 'Takimet e tua',
  your_appointments_service_assistance: 'suport',
  your_appointments_no_appointment_description_admin: 'Servis, zgjidhje të problemeve, informacion rreth produkteve ose shërbimeve të reja.',
  your_appointments_no_appointment_subtitle_admin: 'Ti mund të rezervosh një takim në adresën që dëshiron ose në zyrat qëndrore Vodafone, me një nga përfaqësuesit tanë të biznesit.',
  your_appointments_no_appointment_button_title: 'Rezervo një takim',
  your_appointments_current_tab: 'Takimet në pritje',
  your_appointments_past_tab: 'Takimet e mëparshme',

  book_appointment_extra_data_placeholder: 'Të dhëna shtesë',
  book_appointment_extra_data_input_not_valid: 'Plotëso fushën',
  book_appointment_street_input_not_valid: 'Plotëso fushën',
  book_appointment_street_placeholder: 'Rruga',
  book_appointment_city_placeholder: 'Qyteti',
  book_appointment_add_location_modal_title: 'Vendos adresën e preferuar për takimin tënd',
  book_appointment_add_location_button_title: 'Ruaj adresën',
  book_appointment_edit_location: 'Modifiko',
  book_appointment_your_address: 'Adresa e takimit',
  book_appointment_error_title: 'Oops!',
  book_appointment_error_message: 'Dicka nuk funksionoi',
  book_appointment_go_back: 'Kthehu pas',
  book_appointment_title: 'Rezervo një takim',
  book_store_appointment_title: 'Rezervo një takim',
  book_appointment_service_duration: 'Kohëzgjatja: %1$s %2$s',

  book_appointment_summary_step_policy_modal_title: 'Politika e kthimit',
  book_appointment_summary_step_terms_modal_title: 'Kushte dhe Afate',
  book_appointment_summary_step_policy_modal_url: 'https://api-web-ci-vfal.vodafone.com/file/bookappointment/al.html',
  book_appointment_summary_step_terms_modal_url: 'https://api-web-ci-vfal.vodafone.com/file/bookappointment/al.html',

  Monday: 'E hënë',
  Tuesday: 'E martë',
  Wednesday: 'E mërkurë',
  Thursday: 'E enjte',
  Friday: 'E premte',
  Saturday: 'E shtunë',
  Sunday: 'E dielë'
}

export default al
